import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoctorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4.75 10V11.25C4.75 12.7688 5.98122 14 7.5 14C9.01878 14 10.25 12.7688 10.25 11.25V9C10.25 8.17157 10.9216 7.5 11.75 7.5C12.5784 7.5 13.25 8.17157 13.25 9V9.5M4.75 10C3.69029 10 2.73451 9.36281 2.32692 8.38461L2.29178 8.30028C1.93414 7.44193 1.75 6.52125 1.75 5.59136V4.25C1.75 3.55964 2.30964 3 3 3M4.75 10C5.80971 10 6.76549 9.36281 7.17308 8.38461L7.20822 8.30028C7.56586 7.44193 7.75 6.52124 7.75 5.59136V4.25C7.75 3.55964 7.19036 3 6.5 3" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.5,
			cy: 3,
			r: .25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 3,
			r: .25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.25,
			cy: 10.5,
			r: .75
		})
	]
});
export default SvgDoctorIcon;
